import { Avatar, Box, Button, Stack, Typography } from '@mui/material';
import { AutoCompleteInput } from 'Components/HookFormInputs/AutoCompleteInput';
import { SuppliersContext } from 'Context/SuppliersContext';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { SUPPLIERS_RESOURCES } from 'Enum/suppliers';
import { useDictionary } from 'Hooks';
import { PurpleX } from 'Images';
import { ITherapySuppliers } from 'Interfaces/therapySuppliers';
import { useContext, useRef } from 'react';
import { useFormContext } from 'react-hook-form';

interface ISpecialization {
  isReset: React.MutableRefObject<boolean>;
}

const Specialization = ({ isReset }: ISpecialization) => {
  const { resources } = useContext(SuppliersContext);
  const { setValue, watch } = useFormContext<ITherapySuppliers>();

  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.Suppliers
  ).therapySearchForm;

  return (
    <Stack
      gap='20px'
      sx={{
        '.MuiOutlinedInput-root': {
          mt: 0,
        },
        '.MuiOutlinedInput-input': { mt: '-10px' },
      }}
    >
      <Typography variant='body2'>{dictionary.specialization}</Typography>
      <Box
        position={'relative'}
        sx={{
          '.MuiAutocomplete-endAdornment': {
            visibility: !!watch('specialty') ? 'hidden' : 'visible',
          },
        }}
      >
        <AutoCompleteInput
          options={
            resources[SUPPLIERS_RESOURCES.profession]?.resources.map(
              (resource) => ({
                id: resource.resourceId,
                value: resource.content,
              })
            ) || []
          }
          name={'specialty'}
          isReset={isReset}
          placeholder={dictionary.specializationPlaceholder}
          areaLabel={dictionary.professionDescription}
          filterOptions={(options) => options}
        />
        {!!watch('specialty') && (
          <Button
            onClick={() => {
              setValue('specialty', null);
              isReset.current = true;
            }}
            sx={{
              height: '40px',
              width: '40px',
              minWidth: '40px',
              position: 'absolute',
              top: '8px',
              right: '4px',
              backgroundColor: 'white',
              zIndex: 1,
            }}
          >
            <Avatar
              alt={dictionary.resetProfession}
              src={PurpleX}
              sx={{ width: '20px', height: '20px' }}
            />
          </Button>
        )}
      </Box>
    </Stack>
  );
};

export default Specialization;
